import React, { useState, useEffect } from 'react';
import ChatbotIcon from './ChatbotIcon';
import ChatbotPopup from './ChatbotPopup';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    // Show notification popup after 2 seconds on first visit
    const hasSeenNotification = localStorage.getItem('thinkverse_chatbot_notification_seen');
    
    if (!hasSeenNotification) {
      const timer = setTimeout(() => {
        setShowNotification(true);
        // Hide notification after 8 seconds
        setTimeout(() => {
          setShowNotification(false);
          localStorage.setItem('thinkverse_chatbot_notification_seen', 'true');
        }, 8000);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleIconClick = () => {
    setIsOpen(true);
    setShowNotification(false);
  };

  return (
    <>
      <ChatbotIcon 
        onClick={handleIconClick} 
        isOpen={isOpen} 
        showNotification={showNotification}
        onDismissNotification={() => setShowNotification(false)}
      />
      <ChatbotPopup isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default Chatbot;
